import { PaymentMethod } from '@fox/finance';
import { Topic } from '../../topics';
import { useState } from 'react';
import { sendUpdate } from 'fox-extensions';

export interface MutationHookProps {
	requestToken: string;
	topics?: Topic[];
}

export interface DeletePaymentMethodMutationHookProps extends MutationHookProps {
	paymentMethod: PaymentMethod;
	useLinkedOrganisationData: boolean;
}

export interface MutationHookTemplateProps extends MutationHookProps {
	url: string;
}

export function useMutation<T, I>(input: MutationHookTemplateProps) {
	const { requestToken, url, topics } = input;
	const [error, setError] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<T>(undefined);

	const mutate = async (model: I): Promise<T> => {
		try {
			setLoading(true);
			setError('');
			const res = await fetch(url, {
				method: 'POST',
				body: JSON.stringify(model),
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					RequestVerificationToken: requestToken
				}
			});
			if (res.ok) {
				const response = await res.json();
				if (response.success === true) {
					setData(response.result);
					setLoading(false);
					if (topics?.length) {
						for (const topic of topics) {
							sendUpdate(topic);
						}
					}
					return response.result;
				} else {
					const err = response.message;
					setLoading(false);
					setError(err);
				}
			} else {
				const err = await res.text();
				setLoading(false);
				setError(err);
			}
		} catch (e) {
			setLoading(false);
			setError(`Error: ${e.message}`);
		}
	};

	return { error, loading, data, mutate };
}
